import { create } from 'zustand';

import type { TokenexBrand } from '../components/ui/CardBrandIcon';

type CreditCardFormStoreState = {
  cardBrand: TokenexBrand;
  cardBrands: string[];
};

type CreditCardFormStoreAction = {
  setCardBrand: (val: TokenexBrand) => void;
  getCardBrand: () => TokenexBrand;
  setCardBrands: (val: string[]) => void;
  getCardBrands: () => string[];
};

export const useCreditCardFormStore = create<
  CreditCardFormStoreState & CreditCardFormStoreAction
>((set, get) => ({
  cardBrand: 'unknown' as TokenexBrand,
  cardBrands: [],
  getCardBrand: () => get().cardBrand,
  setCardBrand: (cardBrand: TokenexBrand) => set(() => ({ cardBrand })),
  getCardBrands: () => get().cardBrands,
  setCardBrands: (cardBrands: string[]) => set(() => ({ cardBrands })),
}));
